var search = function search(value, options) {
  var searchString = value.toLowerCase();
  return options.filter(function (_ref) {
    var label = _ref.label;
    return label.toLowerCase().includes(searchString);
  });
};
export default search;